import { createType } from './create-type.js';
import {
  UnionTypeDescription,
  UnionTypeDiscriminator,
} from './union-type-description.js';
import { TypeDescription } from './type-description.js';

//export const union = <T extends [Type<any, any>, ...Type<any, any>[]]>(
export const union = <T extends TypeDescription[]>(
  name: string,
  kinds: T,
  discriminatorKey?: string,
) =>
  createType<UnionTypeDescription<T[number]['_output']>>({
    description: {
      type: 'union',
      unionTypes: kinds,
      name,
      discriminator: discriminatorKey
        ? kinds.reduce<UnionTypeDiscriminator>(
            (map, kind) => {
              if (kind.type === 'object') {
                const keyType = kind.object[discriminatorKey];
                if (keyType && keyType.type === 'literal') {
                  if (typeof keyType.constant === 'string') {
                    map.mappings[keyType.constant] = kind;
                  } else {
                    map.unmapped.push(kind);
                  }
                } else {
                  map.unmapped.push(kind);
                }
              } else {
                map.unmapped.push(kind);
              }

              return map;
            },
            { key: discriminatorKey, mappings: {}, unmapped: [] },
          )
        : undefined,
    },
  });
